import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/vapp-192.png")